module.exports = __webpack_public_path__ + "static/media/starterguidestep7.92153321.png";